'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '#pplx/frontend/aether/components/Link/index.js';
import { talkToSalesCtaSelectedEvent } from '#pplx/frontend/apps/ask/talk-to-sales/analytics.js';
import { useTalkToSalesCta } from '#pplx/frontend/apps/ask/talk-to-sales/useTalkToSalesCta.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';
const SURFACE = 'orgSettingsNav';
/**
 * "Contact sales" CTA anchored at the bottom of the org settings sidebar.
 * Owns its bottom-pinning layout (`mt-auto` against the sidebar's flex
 * column) so the sidebar stays a one-line insertion. Self-gates on
 * eligibility and renders nothing when ineligible, so sales-assisted orgs
 * never see it.
 */
export const TalkToSalesNavCta = () => {
    const cta = useTalkToSalesCta(SURFACE);
    if (!cta) {
        return null;
    }
    return (_jsx("div", { className: "mt-auto flex justify-center pt-4 md:px-2", children: _jsx(Link, { size: "small", variant: "secondary", pill: true, href: cta.href, target: "_blank", rel: "noopener noreferrer", track: talkToSalesCtaSelectedEvent({
                name: 'enterprise talk to sales cta selected',
                data: { surface: SURFACE, audience: cta.audience, destination: cta.destination },
            }), children: _jsx(FormattedMessage, { defaultMessage: "Contact sales", description: "Button anchored at the bottom of the org settings sidebar that opens the sales contact flow", id: "ad07d1bd38" }) }) }));
};
//# sourceMappingURL=TalkToSalesNavCta.js.map